(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskForm', {
    bindings: {
      taskId: '<',
      actionDetails: '<',
      taskType: '<',
      taskStateDetails: '<',
      onFormSubmit: '&',
      hideForm: '&'
    },
    controller: UserTaskFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-form/user-task-form.view.html'
  });

  function UserTaskFormController(
    $filter,
    $q,
    $scope,
    $uibModal,
    accountsService,
    toaster,
    userTasksService,
    utils
  ) {
    'ngInject';

    const vm = this;

    const translationString = {
      'CallVoid_Conversion': {
        'approve': 'CALL_VOID_APPROVE_SUCCESS_MESSAGE',
        'reject': 'CALL_VOID_REJECT_SUCCESS_MESSAGE'
      },
      'offer_participation_request': {
        'approve': 'APPROVE_SUCCESS_MESSAGE',
        'reject': 'REJECT_SUCCESS_MESSAGE'
      }
    };

    vm.formArgs = {};

    vm.$onChanges = onChanges;
    vm.handleSubmit = handleSubmit;
    vm.onParameterValueChanged = onParameterValueChanged;
    vm.confirmAction = confirmAction;
    vm.cancelModal = cancelModal;

    function onChanges() {
      if (_toDirectlyShowConfirmation(vm.actionDetails)) {
        _showConfirmationModal(vm.actionDetails);
        vm.hideFormForConfirmation = true;
      }
    }

    function handleSubmit() {
      if (vm.taskType === 'CallVoid_Conversion' && vm.actionDetails.actionName === 'approve') {
        _showCallVoidApprovalConfirmation();
        return $q.when({});
      } else {
        return confirmAction();
      }
    }

    function confirmAction() {
      return _sendActionDetails(_getActionData(vm.formArgs)).then(function(response) {
        if (response.data.errors && response.data.errors.length) {
          toaster.pop('error', response.data.errors[0].errorMessage);
        } else {
          _showActionSuccessMessage(vm.actionDetails.actionName, vm.taskType);
          vm.onFormSubmit({
            actionName: vm.actionDetails.actionName,
            newJobDetails: response.data.job
          });
        }

      }).catch(utils.errorHandler);
    }

    function onParameterValueChanged(param, value) {
      vm.formArgs[param] = value;
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.confirmationText = null;
      }
    }

    function _showCallVoidApprovalConfirmation() {
      vm.formArgs = _getActionData(vm.formArgs);
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-form/call-void-approve-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function _toDirectlyShowConfirmation(action) {
      return action && action.actionArgs && action.actionArgs.length === 1 && _.find(action.actionArgs, { name: 'actionName' });
    }

    function _showConfirmationModal(action) {
      vm.confirmationText = {
        actionName: action.actionName,
        actionTitle: _.capitalize(action.actionName)
      };

      vm.showInlineConfirmationBox = true;
    }

    function _sendActionDetails(data) {
      return userTasksService.sendActionDetails(accountsService.currentAccountId, vm.taskId, {
        args: data
      });
    }

    function _getActionData(formArgs) {
      const formArgsCopy = angular.copy(formArgs);
      _.forEach(vm.actionDetails.actionArgs, function(arg) {
        if(arg.isHidden && arg.defaultValue) {
          formArgsCopy[arg.name] = arg.defaultValue;
        }
      });
      formArgsCopy.actionName = vm.actionDetails.actionName;
      return formArgsCopy;
    }

    function _showActionSuccessMessage(actionName, taskType) {
      let message;
      if(translationString[taskType] && translationString[taskType][actionName]) {
        message = $filter('translate')(translationString[taskType][actionName]);
      } else {
        message = $filter('translate')('ACTION_SUCCESS_MESSAGE');
      }
      toaster.pop('success', $filter('translate')(message));
    }


  }
})();
